module.exports = __webpack_public_path__ + "img/game_main_pc_32_off.17a864d5.png";